// src/assets/icons/index.jsx

import React from "react";
import {
  Search,
  ShoppingCart,
  User,
  Menu,
  ChevronDown,
  ChevronRight,
  ChevronLeft,
  Zap,
  Star,
  X,
  MapPin ,
} from "lucide-react";

export const SearchIcon = ({ size = 24, className = "cursor-pointer" }) => {
  return <Search size={size} className={className} strokeWidth={2} />;
};
export const XIcon = ({ size = 21, className = "cursor-pointer" }) => {
  return <X size={size} className={className} strokeWidth={2} />;
};
export const CartIcon = ({ className = "cursor-pointer md:w-8 w-5" }) => {
  return (
    <ShoppingCart
      className={className}
      strokeWidth={2}
    />
  );
};

export const UserIcon = ({ size = 24, className = "cursor-pointer" }) => {
  return <User size={size} className={className} strokeWidth={2} />;
};

export const MenuIcon = ({ size = 24, className = "cursor-pointer" }) => {
  return <Menu size={size} className={className} strokeWidth={2} />;
};

export const DropdownIcon = ({ size = 16, className = "cursor-pointer" }) => {
  return (
    <ChevronDown
      size={size}
      className={className}
      strokeWidth={2}
    />
  );
};
export const LeftIcon = ({ size = 26, className = "cursor-pointer" }) => {
  return (
    <ChevronLeft
      size={size}
      className={className}
      strokeWidth={1}
    />
  );
};
export const RightIcon = ({ size = 26, className = "cursor-pointer" }) => {
  return (
    <ChevronRight
      size={size}
      className={className}
      strokeWidth={1}
    />
  );
};

export const FlashIcon = ({ size = 14, className = "cursor-pointer" }) => {
  return <Zap size={size} className={className} strokeWidth={2} />;
};
export const StarIcon = ({ className="fill-[var(--primary-medium)] text-[var(--primary-medium)] md:w-[11px] w-4"})=>{
  return <Star className={className} strokeWidth={2} />
}
export const LocationIcon = ({ size = 14, className = "cursor-pointer" }) => {
  return <MapPin  size={size} className={className} strokeWidth={2} />;
};